import React, { useEffect, useState } from 'react';
import Select from 'react-select'
import axios from 'axios';
import '../../styles/assetModify/assetModify.css'; // Import the CSS file
import '../../styles/form/form.css';
import Popup from '../../components/popup/Popup';
import { useNavigate, useParams } from 'react-router-dom';
import baseUrl, { corporateUrl } from '../../config/config';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faUserCheck, faCircleInfo, faAngleUp, faAngleDown } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import up_arrow from './../../svgs/chevron-down-circle-outline.svg';
import down_arrow from './../../svgs/chevron-up-circle-outline.svg';
import api from '../../api/api';

import icons from '../../data/assetTypes';
import { MdSpeaker } from "react-icons/md";
import { BsTrash, BsCheckCircleFill, BsCircle } from 'react-icons/bs';

const CreateAsset = ({ setActiveIndex }) => {
  const { id } = useParams();
  const token = localStorage.getItem('token'); //retrive the token from the local storage
  const event = 'Created';
  const isAdmin = localStorage.getItem("access_type");
  const navigate = useNavigate();
  const [assetNumIdData, setAssetNumId] = useState('');
  const [formData, setFormData] = useState({
    assetNumId: '',
    assetNumber: '',
    employeeId: Number(id),
    assetTypeId: '',
    status: 'New/Verified',
    allocatedPerson: '',
    allocatedPersonId: '',
    seat_allocation: '',
    roleName: '',
    yearOfPurchase: '',
    remarks: '',
    parentAsset: '',
    purpose: '',
    fields: [],
    attachments: [],
  });
  const [datepickerSelected, setDatepickerSelected] = useState('');
  const [optionsData, setOptionsData] = useState([]);
  const [activityData, setActivityData] = useState({
    assetNumber: '',
    employeeId: id,
    event: event,
  });

  const [popup, setPopup] = useState(null);
  const [allEmployees, setAllEmployees] = useState([])
  const [selectedOption, setSelectedOption] = useState(null);
  const [details, setDetails] = useState([]);
  const [secondaryAssets, setSecondaryAssets] = useState([]);
  const [secondaryAssetDetails, setSecondaryAssetDetails] = useState([]);
  const [selectedDescription, setSelectedDescription] = useState('');
  const [assetIcons, setAssetIcons] = useState(null);
  const [assetNumberSelection, setAssetNumberSelection] = useState('');
  const [assetTypes, setAssetTypes] = useState([]);
  const [fields, setFields] = useState([]);
  const [attachmentType, setAttachmentType] = useState('');
  const [attachmentName, setAttachmentName] = useState('');
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [deletedNewIndices, setDeletedNewIndices] = useState([]);
  const [newActiveStatus, setNewActiveStatus] = useState({});
  const [documentTypes, setDocumentTypes] = useState([]);
  const [newDocTypeName, setNewDocTypeName] = useState('');
  const [showNewDocTypeInput, setShowNewDocTypeInput] = useState(false);
  const [isDocTypeDropdownOpen, setIsDocTypeDropdownOpen] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const docTypeDropdownRef = React.useRef(null);
  const fetchDetails = async () => {
    try {
      if (!token) {
        navigate("/login");
      } else {
        const response = await api.get(`${baseUrl}/api/all-assets-details`, {
          headers: {
            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
          },
        });
        const filtered = response.data.results.filter(asset =>
          asset.assetType.assetCategory &&
          asset.assetType.assetCategory.toLowerCase() === 'secondary' &&
          asset.assetDetails.status.match('In Stock')
        );
        setDetails(filtered);
        const asseteData = response.data.results;
        const iconsMap = {};
        asseteData.forEach(asset => {
          const matchingIcon = icons.find(icon => icon['type'] === asset.assetType.assetType);
          if (matchingIcon) {
            iconsMap[asset.assetType.assetType] = matchingIcon["icon"];
          } else {
            console.warn(`No matching icon found for assetType: ${asset.assetType.assetType}`);
          }
        });
        setAssetIcons(iconsMap);
      }
    } catch (error) {
      console.error('Error fetching details:', error);
    }
  };
  useEffect(() => {
    getAllEmployees();
    fetchDetails();
  }, [])

  useEffect(() => {
    console.log("create assets 101: ", details);
  }, [details]);

  useEffect(() => {
    const fetchAssetTypes = async () => {
      try {
        const response = await api.get(`${baseUrl}/api/all-asset-types`, {
          headers: {
            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
          },
        });
        setAssetTypes(response.data);
      } catch (error) {
        console.error('Error fetching asset types:', error);
      }
    };
    fetchAssetTypes();
  }, []);

  // Fetch document types
  const fetchDocumentTypes = async () => {
    try {
      const response = await api.get(`${baseUrl}/api/document-types`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setDocumentTypes(response.data);
    } catch (error) {
      console.error('Error fetching document types:', error);
    }
  };

  useEffect(() => {
    fetchDocumentTypes();
  }, []);

  // Create new document type
  const handleCreateDocumentType = async () => {
    if (!newDocTypeName.trim()) {
      alert('Please enter a document type name');
      return;
    }
    try {
      const response = await api.post(`${baseUrl}/api/document-types`,
        { documentTypeName: newDocTypeName.trim() },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        }
      );
      setDocumentTypes([...documentTypes, response.data]);
      setNewDocTypeName('');
      setShowNewDocTypeInput(false);
      setAttachmentType(response.data.documentTypeName);
    } catch (error) {
      console.error('Error creating document type:', error);
      alert(error.response?.data?.message || 'Error creating document type');
    }
  };

  // Delete document type
  const handleDeleteDocumentType = async (docTypeId, docTypeName) => {
    if (!window.confirm(`Are you sure you want to delete "${docTypeName}"?`)) {
      return;
    }
    try {
      await api.delete(`${baseUrl}/api/document-types/${docTypeId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });
      setDocumentTypes(documentTypes.filter(dt => dt.documentTypeId !== docTypeId));
      if (attachmentType === docTypeName) {
        setAttachmentType('');
      }
    } catch (error) {
      console.error('Error deleting document type:', error);
      alert(error.response?.data?.message || 'Error deleting document type');
    }
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (docTypeDropdownRef.current && !docTypeDropdownRef.current.contains(event.target)) {
        setIsDocTypeDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const getAllEmployees = async () => {

    const token = localStorage.getItem('token');
    try {
      const response = await api.get(`${corporateUrl}/api/all-users-asset`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        },
      });
      setAllEmployees(response.data)
      const options = response.data.map(employee => ({
        value: employee.employeeId,
        label: employee.first_name + ' ' + employee.last_name + ' ( ' + employee.employeeId + ' ) ',
      }));
      setOptionsData(options);
    } catch (error) {
      console.error('Error fetching employees', error);
    }
  };

  const handleAssetTypeChange = async (e) => {
    const assetId = e.target.value;
    const asssetDetails = assetTypes.find(type => type.assetTypeId.toString() === assetId);
    if (asssetDetails) {
      setFormData({
        ...formData,
        assetTypeId: assetId,
        assetCategory: asssetDetails.assetCategory,
        assetType: asssetDetails.assetType,
        fields: []
      });
      let sanitizedValue = asssetDetails.assetType.replace('/', '');
      const newAssetNumberSelection = 'PSL/' + sanitizedValue.slice(0, 3).toUpperCase();

      // Preserve the year and number part if they exist
      const parts = assetNumberSelection.split('/');
      const currentYear = parts[2] || '';
      const numberPart = parts[3] || '';

      // Set assetNumberSelection in the desired format
      setAssetNumberSelection(newAssetNumberSelection + '/' + currentYear + (numberPart ? '/' + numberPart : ''));
    } else {
      setFormData({
        ...formData,
        assetTypeId: '',
        assetCategory: '',
        assetType: '',
        fields: []
      });
      setAssetNumberSelection('');
      setDatepickerSelected('')
      setFields([]);
    }
    try {
      const response = await api.get(`${baseUrl}/api/get-fields/${assetId}`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        },
      });
      if (response.data && response.data.length > 0) {
        setFields(response.data);
        // Initialize formData.fields based on the fetched fields
        setFormData(prevFormData => ({
          ...prevFormData,
          fields: response.data.map(field => ({ feildId: field.feildId, value: '' }))
        }));
      } else {
        setFields([]);
        setFormData(prevFormData => ({
          ...prevFormData,
          fields: []
        }));
      }

    } catch (error) {
      console.error('Error fetching fields:', error);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    if (name !== 'allocatedPerson' && value !== null) {
      // Update formData and activityData when a value is selected
      setFormData({
        ...formData,
        [name]: value,
      });

      setActivityData({
        ...activityData,
        [name]: value,
      });

      // Handle assetType specific logic
      // if (name === 'assetType') {


      //   const icon = icons.find(icon => icon.type === value); // Use === for comparison
      //   if (icon) {
      //     // setFormData({
      //     //   ...formData,
      //     //   assetCategory: icon.category,
      //     //   assetType: value
      //     // });
      //     // Reset secondary details and assets if needed
      //     setSecondaryAssetDetails([]);
      //     setSecondaryAssets([]);
      //   }
      // }
    } else {
      // Handle resetting formData and activityData when value is null or allocatedPerson is changed
      setFormData({
        ...formData,
        [name]: null,
      });

      setActivityData({
        ...activityData,
        [name]: null,
      });

      // Reset secondary details and assets if needed
      if (name === 'assetType') {
        setSecondaryAssetDetails([]);
        setSecondaryAssets([]);
      }
    }
  };


  const handleSelectPersonChange = (data, action) => {
    if (action.name === 'allocatedPerson' && data !== null) {

      console.log('empDA', data.value)
      console.log('EMP', allEmployees);
      const personValue = allEmployees?.find(emp => emp.employeeId === data.value);
      setSelectedOption(data)
      setFormData({
        ...formData,
        [action.name]: personValue.first_name + ' ' + personValue.last_name,
        seat_allocation: personValue.seat_allocation,
        role: personValue.other_role ? personValue.other_role : personValue.role,
        allocatedPersonId: Number(personValue.employeeId),
        status: data.value ? 'Assigned' : 'New/Verified', // Set status to 'Assigned' if an employee is selected, otherwise set to 'In Stock'
      });

      setActivityData({
        ...activityData,
        [action.name]: personValue.first_name,
        allocatedPersonId: Number(personValue.employeeId)
      });
    } else {
      setSelectedOption(null)
      setFormData({
        ...formData,
        [action.name]: "",
        seat_allocation: "",
        role: "",
        allocatedPersonId: "",
        status: data === null ? 'New/Verified' : 'Assigned',
      });

      setActivityData({
        ...activityData,
        [action.name]: null,
      });
    }
  };

  const handleCardClick = (assetNumber) => {
    const isSelected = secondaryAssets.includes(assetNumber);
    let updatedSecondaryAssets;
    if (isSelected) {
      updatedSecondaryAssets = secondaryAssets.filter(asset => asset !== assetNumber);
    } else {
      updatedSecondaryAssets = [...secondaryAssets, assetNumber];
    }
    setSecondaryAssets(updatedSecondaryAssets);
    const updatedSecondaryAssetDetails = details.filter(item => updatedSecondaryAssets.includes(item.assetDetails.assetNumber));
    setSecondaryAssetDetails(updatedSecondaryAssetDetails);
  };

  const handleYearChange = async (date) => {
    setDatepickerSelected(date);
    let assetNumberStatusResponse;
    // Extract year from date
    const year = new Date(date).getFullYear();
    if (year) {
      assetNumberStatusResponse = await api.get(`${baseUrl}/api/asset-number-state/${year}/${formData.assetTypeId}`, {
        headers: {
          'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
        },
      });

      setAssetNumId(assetNumberStatusResponse.data.nextAssetNumber);
    }

    // Preserve the first part of assetNumberSelection
    const parts = assetNumberSelection.split('/');
    const firstPart = parts.slice(0, 2).join('/');

    // Update assetNumberSelection with the new year and add number part '1000'
    setAssetNumberSelection(firstPart + '/' + year.toString() + '/' + assetNumberStatusResponse.data.nextAssetNumber);
    setFormData({
      ...formData,
      yearOfPurchase: year,
    });

    setActivityData({
      ...activityData,
      yearOfPurchase: date,
    });
  }

  useEffect(() => {
    if (assetNumberSelection.length > 0) {
      setFormData({
        ...formData,
        assetNumId: assetNumIdData,
        assetNumber: assetNumberSelection,
      });

      setActivityData({
        ...activityData,
        assetNumber: assetNumberSelection,
      });
    }
  }, [assetNumberSelection, datepickerSelected]);

  const handleFieldChange = (index, e) => {
    const newFields = formData.fields.map((field, idx) => {
      if (index === idx) {
        return { ...field, value: e.target.value };
      }
      return field;
    });
    setFormData({ ...formData, fields: newFields });
  };

  const groupFields = (arr, groupSize) => {
    const group = [];
    for (let i = 0; i < arr.length; i += groupSize) {
      group.push(arr.slice(i, i + groupSize));
    }
    return group;
  };

  const handleShowMore = (assetNumber) => {
    setSelectedDescription(assetNumber);
  }

  const renderFieldDetails = (fieldDetails = [], specifications = []) => {
    return fieldDetails.map((field) => {
      const spec = specifications.find((spec) => spec.feildId === field.feildId);
      let option;

      if (field.fieldType === "dropdown" && spec) {
        const valueAsNumber = Number(spec.fieldValue);
        option = field.options ? field.options.find((option) => option.value === valueAsNumber) : '';
      }
      return (
        <>
          <div className='asset_details_row_section' key={field.fieldId}>
            <div className='asset_details_label'>{field.fieldName}:</div>
            <div className='asset_details_desc'>{field.fieldType === "dropdown" ? option?.label : spec ? spec.fieldValue : 'N/A'}</div>
          </div>
          {isAdmin === '1' && field.feildName?.toLowerCase() === 'windows license' && (
            <div className='asset_details_row_section' key={field.fieldId}>
              <div className='asset_details_label'>{field.fieldName}:</div>
              <div className='asset_details_desc'>{field.fieldType === "dropdown" ? option?.label : spec ? spec.fieldValue : 'N/A'}</div>
            </div>
          )}
        </>
      );

    });
  };

  const handleAttachmentFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) {
      setAttachmentFile(null);
      return;
    }

    if (file.type !== 'application/pdf' && !file.name.toLowerCase().endsWith('.pdf')) {
      alert('Only PDF files are allowed');
      e.target.value = null;
      setAttachmentFile(null);
      return;
    }

    setAttachmentFile(file);
  };

  const handleAddAttachment = (e) => {
    e.preventDefault();

    if (!attachmentType || !attachmentName.trim() || !attachmentFile) {
      alert('Please select document type, enter name and choose a PDF file.');
      return;
    }

    const fileUrl = URL.createObjectURL(attachmentFile);

    const newAttachment = {
      type: attachmentType,
      name: attachmentName.trim(),
      fileName: attachmentFile.name,
      file: attachmentFile,
      url: fileUrl,
    };

    setFormData((prev) => ({
      ...prev,
      attachments: [...(prev.attachments || []), newAttachment],
    }));

    setAttachmentType('');
    setAttachmentName('');
    setAttachmentFile(null);

    const fileInput = document.getElementById('attachmentFile');
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitted(true);


    // Validation: Check specific fields
    const fieldLabels = {
      'assetNumber': 'Asset Number',
      'employeeId': 'Employee',
      'assetTypeId': 'Asset Type',
      'assetCategory': 'Category',
      'yearOfPurchase': 'Purchased Year',
      'purpose': 'Purpose'
    };

    const requiredFields = [
      'assetNumber',
      'employeeId',
      'assetTypeId',
      'assetCategory',
      'yearOfPurchase'
    ];

    const emptyFields = requiredFields.filter(field => !formData[field] || (typeof formData[field] === 'string' && !formData[field].trim()));

    // Purpose is mandatory for PC/Desktop
    if (formData.assetType === 'PC/Desktop' && (!formData.purpose || !formData.purpose.trim())) {
      emptyFields.push('purpose');
    }

    if (emptyFields.length > 0) {
      const missingLabels = emptyFields.map(field => fieldLabels[field] || field).join(', ');
      setPopup({
        type: 'error',
        message: `${missingLabels} ${emptyFields.length === 1 ? 'field' : 'fields'} must be filled out`
      });
      return;
    }

    setActivityData(prevState => {
      let updatedFields = [];

      if (prevState.allocatedPerson && prevState.allocatedPersonId) {
        updatedFields = [
          {
            key: "allocatedPerson",
            prev_Value: "", // Assuming no previous value; update if needed
            current_value: prevState.allocatedPerson || ""
          },
          {
            key: "allocatedPersonId",
            prev_Value: "", // Assuming no previous value; update if needed
            current_value: prevState.allocatedPersonId || ""
          }
        ];
      }

      // Ensure updatedFields is always an array and merge with any existing fields
      return {
        ...prevState,
        updatedFields: [...(prevState.updatedFields || []), ...updatedFields]
      };
    });

    try {
      if (!token) {
        navigate("/login")
      } else {
        const formDataToSend = new FormData();

        formDataToSend.append('assetNumId', formData.assetNumId || '');
        formDataToSend.append('assetNumber', formData.assetNumber || '');
        formDataToSend.append('employeeId', formData.employeeId != null ? formData.employeeId : '');
        formDataToSend.append('assetTypeId', formData.assetTypeId || '');
        formDataToSend.append('assetCategory', formData.assetCategory || '');
        formDataToSend.append('status', formData.status || '');
        formDataToSend.append('allocatedPerson', formData.allocatedPerson || '');
        formDataToSend.append('allocatedPersonId', formData.allocatedPersonId != null ? formData.allocatedPersonId : '');
        formDataToSend.append('seat_allocation', formData.seat_allocation || '');
        formDataToSend.append('role', formData.role || '');
        formDataToSend.append('yearOfPurchase', formData.yearOfPurchase || '');
        formDataToSend.append('remarks', formData.remarks || '');
        formDataToSend.append('parentAsset', formData.parentAsset || '');
        formDataToSend.append('purpose', formData.purpose || '');

        // Dynamic fields
        formDataToSend.append('fields', JSON.stringify(formData.fields || []));

        // Attachments metadata (no file/url) - filter out deleted and include active status
        const filteredAttachments = (formData.attachments || [])
          .filter((_, idx) => !deletedNewIndices.includes(idx));

        const attachmentsMeta = filteredAttachments.map((att, idx) => {
          // Find the original index before filtering
          const originalIdx = formData.attachments.findIndex(a => a === att);
          return {
            type: att.type,
            name: att.name,
            fileName: att.fileName,
            active: newActiveStatus[originalIdx] === true,
          };
        });
        formDataToSend.append('attachments', JSON.stringify(attachmentsMeta));

        // Attachment files - only non-deleted
        filteredAttachments.forEach(att => {
          if (att.file) {
            formDataToSend.append('attachmentFiles', att.file);
          }
        });

        const res = await api.post(`${baseUrl}/api/asset-create`, formDataToSend, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data',
          },
        });

        const activityRes = await api.post(`${baseUrl}/api/add-activity`, activityData, {
          headers: {
            'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
          },
        });

        const employee1 = allEmployees.find(emp => emp.employeeId === id);
        const allocatedPersonName = employee1 ? employee1.first_name : '';

        // Assuming secondaryAssetDetails is an array of objects, each containing an objId
        for (const subAsset of secondaryAssetDetails) {
          const objId = subAsset.assetDetails._id;
          console.log('objId', objId);// Extract objId from the current device object
          subAsset.status = 'Assigned';
          subAsset.allocatedPersonId = Number(formData.allocatedPersonId);
          subAsset.parentAsset = formData.assetNumber;
          subAsset.fields = [];
          console.log('subasset', subAsset);
          const response = await api.put(`${baseUrl}/api/asset-update/${objId}`, subAsset, {
            headers: {
              'Authorization': `Bearer ${token}`, // Include the token in the Authorization header
            },
          });

          // Do something with the response if needed
          console.log('Asset details for objId:', objId, response.data);
        }

        //setPopup({ type: 'success', message: res.data });
        setFormData({
          assetNumId: '',
          assetNumber: '',
          employeeId: Number(id),
          assetTypeId: '',
          status: 'New/Verified',
          allocatedPerson: '',
          allocatedPersonId: '',
          seat_allocation: '',
          roleName: '',
          yearOfPurchase: '',
          remarks: '',
          parentAsset: '',
          purpose: '',
          fields: [],
          attachments: [],
        });

        if (res.data === 'Already Registered With This employee id') {
          // User found, navigate to the status page
          setPopup({ type: 'error', message: 'Already Registered The Device' });
        } else {
          setPopup({ type: 'success', message: res.data });
          setActiveIndex(3);
          navigate(`/all-assets`);
        }
      }
    } catch (error) {
      console.error('Error registering device:', error);
      if (error.response && error.response.data) {
        console.log('errorData', error.response.data);
        setPopup({ type: 'error', message: "there is a error" });
      } else {
        setPopup({ type: 'error', message: 'Registration not completed due to some technical issues' });
      }
    }

  };

  const handleLoginClick = () => {
    navigate("/login")
  }

  const closePopup = () => {
    setPopup(null);
  };

  return (
    <div className="content-section col-12 col-md-12 col-xl-11 asset-main">
      <div className='container'>
        <div className="assethead-head" >
          <div className="activitylog-heading">
            <h3>New Asset</h3>
          </div>
        </div>
        <form className="asset-form" onSubmit={handleSubmit}>
          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faCheckCircle} />
              <span className='form-section-label'>Asset </span>
            </div>
            <div className="form-row asset-first-details-section">

              <div className="form-group">
                <label htmlFor="assetType">Asset Type:<span className="bg-red">*</span></label>
                {/* <select id="assetType" name="assetType" value={formData.assetType} onChange={handleChange}>
                  {icons.map((device, index) => (
                    <option key={index} value={device.type}>{device.type}</option>
                  ))}
                </select> */}
                <select id="assetType" name="assetType" value={formData.assetTypeId} onChange={handleAssetTypeChange} required>
                  <option value="">Select Asset Type</option>
                  {assetTypes.map(type => (
                    <option key={type.assetTypeId} value={type.assetTypeId}>
                      {type.assetType}
                    </option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="assetCategory" className='mr-2'>Category: <span className="bg-red">*</span></label>
                <input id="assetCategory" name="assetCategory" value={formData.assetCategory} readOnly />
              </div>

              <div className="form-group assetyearpicker">
                <label htmlFor="yearOfPurchase">Purchased Year: <span className="bg-red">*</span></label>
                <DatePicker
                  selected={datepickerSelected}
                  onChange={handleYearChange}
                  showYearPicker
                  dateFormat="yyyy"
                  className="date-own form-control"
                  placeholderText="Select year"
                  disabled={!formData.assetTypeId}
                />
              </div>

              <div className="form-group">
                <label htmlFor="assetNumber">Asset Number: <span className="bg-red">*</span></label>
                <input type="text" id="assetNumber" name="assetNumber" value={assetNumberSelection} readOnly />
              </div>

              {formData.assetType === 'PC/Desktop' && (
                <div className="form-group">
                  <label htmlFor="purpose">Purpose:<span className="bg-red">*</span></label>
                  <select id="purpose" name="purpose" value={formData.purpose} onChange={handleChange} required>
                    <option value="">Select Purpose</option>
                    <option value="System">System</option>
                    <option value="Server">Server</option>
                  </select>
                  {submitted && (!formData.purpose || !formData.purpose.trim()) && (
                    <span className="error-message">Please select a purpose</span>
                  )}
                </div>
              )}

              <div className="form-group readonly-group">
                <label htmlFor="status" className='mr-2'>Status:</label>
                <input
                  type="text"
                  id="readOnlyStatus"
                  className={formData.status == 'New/Verified' ? 'read-only instock' : 'read-only'}
                  name="readOnlyStatus"
                  value={formData.status}
                  readOnly
                />
              </div>
            </div>
          </div>

          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faUserCheck} />
              <span className='form-section-label'>Allocated </span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="allocatedPerson" className='mr-2'>Allocated Details:</label>
                {
                  optionsData ?
                    <>
                      <Select
                        isClearable={true}
                        id="allocatedPerson"
                        closeMenuOnSelect={true}
                        name="allocatedPerson"
                        value={selectedOption}
                        defaultValue={selectedOption}
                        onChange={handleSelectPersonChange}
                        options={optionsData}
                        theme={(theme) => ({
                          ...theme,
                          borderRadius: 0,
                          colors: {
                            ...theme.colors,
                            primary25: '#e7daef',
                            primary: '#5c2680',
                          },
                        })} />
                    </>

                    :
                    <>No data</>
                }
              </div>

              <div className="form-group">
                <label htmlFor="role">Role:</label>
                <input type="text" id="role" name="role" value={selectedOption ? formData.role : ''} readOnly />
              </div>
              <div className="form-group">
                <label htmlFor="">Seat Allocation:</label>
                <input type="text" id="seat_allocation" name="seat_allocation" value={selectedOption ? formData.seat_allocation : ''} readOnly />
              </div>
            </div>
          </div>

          {(formData.assetCategory && formData.assetCategory.toLowerCase() === 'primary') && (formData.allocatedPerson != '') && (
            <div className='form-section-description'>
              <div className='form-section-head'>
                <FontAwesomeIcon className="font-icons" icon={faUserCheck} />
                <span className='form-section-label'>Secondary Devices </span>
              </div>
              <div className="form-row-h">
                {details.length !== 0 ? (<label htmlFor="allocatedPerson" className='col-4 mr-2 pl-2'>Available devices</label>) : (<label htmlFor="allocatedPerson" className='col-4 mr-2 pl-2'>No available secondary devices</label>)}
                <div className="form-group_horizontal">
                  {
                    optionsData ?
                      <>
                        {details.map((item, index) =>
                          <div className='asset-item-main col-auto'>
                            <div className={`asset-card ${secondaryAssets.includes(item.assetDetails?.assetNumber) ? 'selected' : ''}`} onClick={() => handleCardClick(item.assetDetails?.assetNumber)}>
                              <div className='asset-item h-100' style={{ width: "24rem" }}>
                                <div className='asset-content-inner  col-12'>
                                  <div className='asset-innersec'>
                                    <div className='asset-item-image-title'>
                                      <div className='asset-item-image-inner'>
                                        {item?.assetType?.assetType === "Speaker" ? <MdSpeaker /> : <FontAwesomeIcon className="font-icons" icon={assetIcons[item.assetType?.assetType]} />}
                                      </div>
                                      <div className='asset-item-number'>
                                        {item.assetDetails?.assetNumber}
                                      </div>
                                    </div>
                                    <div className='asset-item-action'>
                                    </div>
                                  </div>


                                  <div className='asset-item-type'>
                                    <span className='asset-label'>Asset Type : </span>
                                    <span className='asset-data'>{item.assetType?.assetType}</span>
                                  </div>

                                  <div className='asset-item-category'>
                                    <span className='asset-label'>Category : </span>
                                    <span className='asset-data'>{item.assetType?.assetCategory}</span>
                                  </div>

                                  <div className={item.allocatedPersonDetails ? 'asset-item-allocated d-flex justify-content-between' : 'asset-item-allocated d-flex justify-content-end'}>
                                    {item.allocatedPersonDetails ?
                                      <div className='asset-allocated-person'>
                                        <span className='asset-label'>Allocated Person : </span>
                                        <span className='asset-data'>{item.allocatedPersonDetails.first_name + ' ' + item.allocatedPersonDetails.last_name}</span>
                                      </div>
                                      : ''}
                                    <div className='asset-status'>
                                      <span className={item.assetDetails.status == 'Assigned' ? 'active' : ''}>{item.assetDetails.status}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                          </div>
                        )}
                      </>

                      :
                      <>No data</>
                  }
                </div>
                {(formData.assetCategory && formData.assetCategory.toLowerCase() === 'primary') && (formData.allocatedPerson !== '') && (secondaryAssets.length > 0) && (
                  <div className='show-details-container'>
                    <div className='form-section-head'>
                      <FontAwesomeIcon className="font-icons" icon={faUserCheck} />
                      <span className='form-section-label'>Secondary Device Details</span>
                    </div>
                    {console.log('secondary', secondaryAssetDetails)}
                    {secondaryAssetDetails.map((secondaryAssetDetails, index) => (
                      <div key={index} className="description_secondary_asset_create_asset">
                        <div className='form-row'>
                          <div className="form-group">
                            <label htmlFor="assetNumber" className='show_info_create_asset_secondary'>Asset Number:</label>
                            <label>{secondaryAssetDetails.assetDetails?.assetNumber}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="assetType" className='show_info_create_asset_secondary'>Asset Type:</label>
                            <label>{secondaryAssetDetails.assetType?.assetType}</label>
                          </div>

                          <div className="form-group">
                            <label htmlFor="assetCategory" className='mr-2 show_info_create_asset_secondary'>Category:</label>
                            <label>{secondaryAssetDetails.assetType?.assetCategory}</label>
                          </div>

                          <div className="form-group assetyearpicker">
                            <label htmlFor="yearOfPurchase" className='show_info_create_asset_secondary'>Purchased Year:</label>
                            <label>{secondaryAssetDetails.assetDetails.yearOfPurchase}</label>
                          </div>

                          <div className="form-group readonly-group">
                            <label htmlFor="status" className='mr-2 show_info_create_asset_secondary'>Status:</label>
                            <label>{secondaryAssetDetails.assetDetails?.status}</label>
                          </div>

                          <div className='show_more' onClick={() => setSelectedDescription(prevDescription => prevDescription === secondaryAssetDetails.assetDetails.assetNumber ? '' : secondaryAssetDetails.assetDetails.assetNumber)}>
                            {/* Show More */}
                            {secondaryAssetDetails.assetDetails.assetNumber === selectedDescription ? '' : ''}
                            <div className='secondary-item-arrow'>
                              {secondaryAssetDetails.assetDetails.assetNumber === selectedDescription ? <FontAwesomeIcon className="font-icons" icon={faAngleUp} /> : <FontAwesomeIcon className="font-icons" icon={faAngleDown} />}
                            </div>
                          </div>

                        </div>
                        {secondaryAssetDetails.assetDetails.assetNumber === selectedDescription && (
                          <>
                            <div className='form-row'>
                              <div className="form-group">
                                <label htmlFor="allocatedPerson" className='mr-2 show_info_create_asset_secondary'>Employee Id:</label>
                                <label>{secondaryAssetDetails.allocatedPersonDetails?.employeeId}</label>
                              </div>

                              <div className="form-group">
                                <label htmlFor="allocatedPerson" className='mr-2 show_info_create_asset_secondary'>Allocated Person:</label>
                                <label>{secondaryAssetDetails?.allocatedPersonDetails ? secondaryAssetDetails.allocatedPersonDetails?.first_name + ' ' + secondaryAssetDetails?.allocatedPersonDetails?.last_name : ''}</label>
                              </div>

                              <div className="form-group">
                                <label htmlFor="role" className='show_info_create_asset_secondary'>Role:</label>
                                <label>{secondaryAssetDetails.allocatedPersonDetails?.roleName}</label>
                              </div>

                              <div className="form-group">
                                <label htmlFor="role" className='show_info_create_asset_secondary'>Seat Allocation:</label>
                                <label>{secondaryAssetDetails.allocatedPersonDetails?.seat_allocation}</label>
                              </div>
                            </div>

                            <div className="form-row main-grid-sec">
                              <div className='row inside-section'>
                                {renderFieldDetails(secondaryAssetDetails?.fieldDetails, secondaryAssetDetails?.specifications)}
                              </div>
                            </div>

                            <div className="form-row">
                              <div className="form-group">
                                <label htmlFor="remarks" className='show_info_create_asset_secondary'>Remarks:</label>
                                <label>{secondaryAssetDetails.assetDetails.remarks}</label>
                              </div>
                            </div>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                )}

              </div>
            </div>
          )}

          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faCircleInfo} />
              <span className='form-section-label'>Asset Specifications</span>
            </div>
            <div className="form-row main-grid-sec">
              {fields && fields.length > 0 ? groupFields(fields, 3).map((fieldRow, rowIndex) => (
                <div key={rowIndex} className="row inside-section">
                  {fieldRow.map((field, index) => (
                    <div key={field.fieldId} className="form-group">
                      <label>
                        {field.fieldName?.charAt(0).toUpperCase() + field.fieldName?.slice(1)}
                        <span className="bg-red">{field.mandatory === true ? ' *' : ''}</span>
                      </label>
                      {field.fieldType === 'text' && (
                        <input
                          type="text"
                          value={(formData.fields[rowIndex * 3 + index] && formData.fields[rowIndex * 3 + index].value) || ''}
                          onChange={(e) => handleFieldChange(rowIndex * 3 + index, e)}
                          required={field.mandatory}
                        />
                      )}
                      {field.fieldType === 'date' && (
                        <input
                          type="date"
                          value={(formData.fields[rowIndex * 3 + index] && formData.fields[rowIndex * 3 + index].value) || ''}
                          onChange={(e) => handleFieldChange(rowIndex * 3 + index, e)}
                          required={field.mandatory}
                        />
                      )}
                      {field.fieldType === 'dropdown' && (
                        <select
                          value={(formData.fields[rowIndex * 3 + index] && formData.fields[rowIndex * 3 + index].value) || ''}
                          onChange={(e) => handleFieldChange(rowIndex * 3 + index, e)}
                          required={field.mandatory}
                        >
                          <option value="">Select an option</option>
                          {field.options.map(option => (
                            <option key={option.key} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  ))}
                </div>
              )) : <div className="row inside-section"><p>No fields available</p></div>}
            </div>
          </div>

          {/* Attachments section */}
          <div className='form-section'>
            <div className='form-section-head'>
              <FontAwesomeIcon className="font-icons" icon={faCircleInfo} />
              <span className='form-section-label'>Attachments</span>
            </div>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="attachmentType">Document Type</label>
                {!showNewDocTypeInput ? (
                  <div ref={docTypeDropdownRef} style={{ position: 'relative' }}>
                    <div
                      onClick={() => setIsDocTypeDropdownOpen(!isDocTypeDropdownOpen)}
                      style={{
                        padding: '8px 12px',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        minHeight: '38px',
                      }}
                    >
                      <span style={{ color: attachmentType ? '#333' : '#999' }}>
                        {attachmentType || 'Select document type'}
                      </span>
                      <span style={{ fontSize: '10px', color: '#666' }}>▼</span>
                    </div>
                    {isDocTypeDropdownOpen && (
                      <div
                        style={{
                          position: 'absolute',
                          top: '100%',
                          left: 0,
                          right: 0,
                          backgroundColor: '#fff',
                          border: '1px solid #ccc',
                          borderRadius: '4px',
                          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                          zIndex: 1000,
                          maxHeight: '200px',
                          overflowY: 'auto',
                        }}
                      >
                        {documentTypes.map((docType) => (
                          <div
                            key={docType.documentTypeId}
                            onClick={() => {
                              setAttachmentType(docType.documentTypeName);
                              setIsDocTypeDropdownOpen(false);
                            }}
                            style={{
                              padding: '8px 12px',
                              cursor: 'pointer',
                              backgroundColor: attachmentType === docType.documentTypeName ? '#f0e6f5' : 'transparent',
                              borderBottom: '1px solid #eee',
                            }}
                            onMouseEnter={(e) => {
                              if (attachmentType !== docType.documentTypeName) {
                                e.currentTarget.style.backgroundColor = '#f9f9f9';
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (attachmentType !== docType.documentTypeName) {
                                e.currentTarget.style.backgroundColor = 'transparent';
                              }
                            }}
                          >
                            {docType.documentTypeName}
                          </div>
                        ))}
                        <div
                          onClick={() => {
                            setShowNewDocTypeInput(true);
                            setIsDocTypeDropdownOpen(false);
                          }}
                          style={{
                            padding: '8px 12px',
                            cursor: 'pointer',
                            color: '#5c2680',
                            fontWeight: 500,
                            borderTop: documentTypes.length > 0 ? '1px solid #ddd' : 'none',
                          }}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#f9f9f9'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          + Add New Type...
                        </div>
                      </div>
                    )}
                  </div>
                ) : (
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="text"
                      value={newDocTypeName}
                      onChange={(e) => setNewDocTypeName(e.target.value)}
                      placeholder="Enter new document type"
                      style={{ flex: 1 }}
                      autoFocus
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          handleCreateDocumentType();
                        }
                      }}
                    />
                    <button
                      type="button"
                      onClick={handleCreateDocumentType}
                      style={{
                        padding: '6px 12px',
                        backgroundColor: '#5c2680',
                        color: '#fff',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Add
                    </button>
                    <button
                      type="button"
                      onClick={() => {
                        setShowNewDocTypeInput(false);
                        setNewDocTypeName('');
                      }}
                      style={{
                        padding: '6px 12px',
                        backgroundColor: '#fff',
                        color: '#666',
                        border: '1px solid #ddd',
                        borderRadius: '4px',
                        cursor: 'pointer',
                      }}
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>

              <div className="form-group">
                <label htmlFor="attachmentName">Document Name</label>
                <input
                  id="attachmentName"
                  name="attachmentName"
                  type="text"
                  value={attachmentName}
                  onChange={(e) => setAttachmentName(e.target.value)}
                  placeholder="Enter document name"
                  disabled={!attachmentType}
                />
              </div>

              <div className="form-group">
                <label htmlFor="attachmentFile">Upload PDF</label>
                <input
                  id="attachmentFile"
                  name="attachmentFile"
                  type="file"
                  accept=".pdf"
                  onChange={handleAttachmentFileChange}
                  disabled={!attachmentName || !attachmentName.trim()}
                />
                <span style={{ fontSize: '12px', display: 'block', marginTop: '4px' }}>
                  Only PDF files are allowed.
                </span>
              </div>

              <div className="form-group" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                <button
                  type="button"
                  className='button'
                  onClick={handleAddAttachment}
                  style={{ width: 'auto', padding: '6px 16px', backgroundColor: '#fff', color: '#5c2680', border: '1px solid #5c2680', borderRadius: '5px' }}
                >
                  + Attach
                </button>
              </div>
            </div>

            {(() => {
              // Filter out deleted attachments
              const allAttachments = (formData.attachments || [])
                .map((att, idx) => ({
                  ...att,
                  originalIndex: idx,
                  isDeleted: deletedNewIndices.includes(idx),
                  isActive: newActiveStatus[idx] === true,
                }))
                .filter(att => !att.isDeleted);

              if (allAttachments.length === 0) return null;

              return (
                <div className="form-row" style={{ marginTop: '10px' }}>
                  <div className="form-group" style={{ width: '100%' }}>
                    <label>Added Attachments:</label>
                    <div
                      style={{
                        border: '1px solid #ddd',
                        borderRadius: '6px',
                        padding: '8px 12px',
                        maxHeight: '200px',
                        overflowY: 'auto',
                        backgroundColor: '#fafafa',
                      }}
                    >
                      {allAttachments.map((att, displayIdx) => (
                        <div
                          key={`new-${att.originalIndex}`}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            padding: '8px 4px',
                            borderBottom: displayIdx !== allAttachments.length - 1 ? '1px solid #e4e4e4' : 'none',
                          }}
                        >
                          {/* Left side: Title and Type */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                            <div style={{ width: '200px', minWidth: '200px' }}>
                              <div style={{
                                fontSize: '13px',
                                fontWeight: 500,
                                color: '#333',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}>
                                <a
                                  href={att.url}
                                  target="_blank"
                                  rel="noreferrer"
                                  style={{ color: '#5c2680', textDecoration: 'underline' }}
                                >
                                  {att.name || 'Untitled Document'}
                                </a>
                              </div>
                              <div style={{
                                fontSize: '12px',
                                color: '#666',
                                marginTop: '2px',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}>
                                {att.type || 'PDF'} <span style={{ color: '#999' }}>({att.fileName || 'PDF'})</span>
                              </div>
                            </div>
                            <div style={{ fontSize: '12px', color: '#888', whiteSpace: 'nowrap' }}>
                              Just now
                            </div>
                          </div>

                          {/* Actions */}
                          <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
                            {/* Active Toggle */}
                            <button
                              type="button"
                              onClick={() => {
                                setNewActiveStatus({
                                  ...newActiveStatus,
                                  [att.originalIndex]: !att.isActive
                                });
                              }}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px 6px',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background-color 0.15s ease',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#ecfdf3';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                              }}
                              title={att.isActive ? "Mark as inactive" : "Mark as active"}
                            >
                              {att.isActive ? (
                                <BsCheckCircleFill style={{ color: '#22c55e', fontSize: '16px' }} />
                              ) : (
                                <BsCircle style={{ color: '#aaa', fontSize: '16px' }} />
                              )}
                            </button>
                            {/* Delete Button */}
                            <button
                              type="button"
                              onClick={() => {
                                setDeletedNewIndices([...deletedNewIndices, att.originalIndex]);
                              }}
                              style={{
                                background: 'none',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px 6px',
                                borderRadius: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                transition: 'background-color 0.15s ease',
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.backgroundColor = '#fee8e7';
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor = 'transparent';
                              }}
                              title="Remove attachment"
                            >
                              <BsTrash style={{ color: '#c8372d', fontSize: '14px' }} />
                            </button>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              );
            })()}
          </div>

          <div className='form-section'>
            <div className="form-row">
              <div className="form-group">
                <label htmlFor="remarks">Remarks:</label>
                <textarea type="text" id="remarks" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>

            </div>
          </div>

          <button className='button asset-submit-btn' type="submit">Create</button>
        </form>

        {popup && <Popup type={popup.type} message={popup.message} onClose={closePopup} />}
      </div>
    </div>

  );
};

export default CreateAsset;
